
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Fragment, FC } from 'react';
import type { GetServerSideProps, } from 'next';
import useTranslation from 'next-translate/useTranslation';
import { TagsListDocument, TagsListQuery, } from '@graphql/generated';
import SEO from '@components/SEO';
import { log } from '@utils/logger';
import { query } from '@graphql/withApollo';
import { Content } from '@components/Layout';
import { TagGrid } from '@components/Tag';
const BlogTagList: FC<{
    data: TagsListQuery;
}> = ({ data }) => {
    const { t } = useTranslation('blog');
    const tags = data?.tags;
    return (<Fragment>
      <SEO title={t('tags.heading')} description={t('tags.description')}/>

      <h1 className="mb-4">{t('tags.heading')}</h1>

      <Content>
        <TagGrid tags={tags}/>
      </Content>
    </Fragment>);
};
const getStaticProps: GetServerSideProps = async ({ locale, defaultLocale, }) => {
    // const variables = {
    //   locales: [
    //     ['es', 'it'].includes(locale as string) ? 'en' : locale,
    //     defaultLocale,
    //   ],
    // }
    const { data, errors } = await query(TagsListDocument);
    if (errors) {
        log.error('Failed to retrieve blog tag static page', { errors });
        throw new Error('Failed to retrieve blog tag page');
    }
    if (!data?.tags) {
        return { notFound: true };
    }
    log.warn("received data", { data });
    return { props: { data }, revalidate: 10000 };
};
export default BlogTagList;
export { BlogTagList };

    async function __Next_Translate__getStaticProps__1898874f675__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/tags',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1898874f675__ as getStaticProps }
  